import environment from "flow/configuration/environment";
import personIdValidator_SE from "flow/common/personIdValidator";
import personIdValidator_FI from "flow/common/personIdValidator_FI";
import personIdValidator_NO from "flow/common/personIdValidator_NO";
import metaCache from "flow/utils/metaCache";

const validatePersonIdSE = personIdValidator_SE.validatePersonId;
const stripTransformSE = personIdValidator_SE.stripTransform;
const doTransformSE = personIdValidator_SE.doTransform;

export function validatePersonId(personId: string): boolean {
    const culture = environment.getCulture();
    const validatePersonIdFI = personIdValidator_FI.validatePersonId;

    switch (culture) {
        case "fi-FI":
        case "sv-FI":
            return validatePersonIdFI(personId);
        case "nb-NO":
            return specialCaseNorway(personId);

        case "sv-SE":
            return validatePersonIdSE(personId);
        default:
            throw new Error(`validatePersonId: Culture ${culture} is not supported`);
    }
}

function specialCaseNorway(personId: string): boolean {
    const validatePersonIdNO = personIdValidator_NO.validatePersonId;
    const allowSwedishSsn = metaCache.lookup("Common.Features.AllowSwedishSsnInNorway", false);

    if (allowSwedishSsn) {
        return validatePersonIdNO(personId) || validatePersonIdSE(personId);
    }

    return validatePersonIdNO(personId);
}

function stripTransform(personId: string): string {
    const culture = environment.getCulture();
    const stripTransformFI = personIdValidator_FI.stripTransform;

    switch (culture) {
        case "fi-FI":
        case "sv-FI":
            return stripTransformFI(personId);
        case "nb-NO":
            return specialCaseNorwayForStripTransform(personId);

        case "sv-SE":
            return stripTransformSE(personId);
        default:
            throw new Error(`stripTransform: Culture ${culture} is not supported`);
    }
}

function specialCaseNorwayForStripTransform(personId: string): string {
    const stripTransformNO = personIdValidator_NO.stripTransform;
    const allowSwedishSsn = metaCache.lookup("Common.Features.AllowSwedishSsnInNorway", false);

    if (allowSwedishSsn) {
        const transformedPersonId = stripTransformNO(personId);
        if (transformedPersonId == "Illegal format") {
            return stripTransformSE(personId);
        }
        return transformedPersonId;
    }
    return stripTransformNO(personId);
}

function doTransform(personId: string): string {
    const culture = environment.getCulture();
    const doTransformFI = personIdValidator_FI.doTransform;

    switch (culture) {
        case "fi-FI":
        case "sv-FI":
            return doTransformFI(personId);
        case "nb-NO":
            return specialCaseNorwayForDoTransform(personId);

        case "sv-SE":
            return doTransformSE(personId);
        default:
            throw new Error(`doTransform: Culture ${culture} is not supported`);
    }
}

function specialCaseNorwayForDoTransform(personId: string): string {
    const doTransformNO = personIdValidator_NO.doTransform;
    const allowSwedishSsn = metaCache.lookup("Common.Features.AllowSwedishSsnInNorway", false);

    if (allowSwedishSsn) {
        const transformedPersonId = personIdValidator_NO.stripTransform(personId); // Only strip can result in "Illegal format" result
        if (transformedPersonId == "Illegal format") {
            return doTransformSE(personId);
        }
        // If not illegal, just fall through
    }
    return doTransformNO(personId);
}

export default {
    validatePersonId: validatePersonId,
    stripTransform: stripTransform,
    doTransform: doTransform
};
